module.exports = __webpack_public_path__ + "static/img/dash-6.22473c54.png";